export default __webpack_public_path__ + "static/media/480_dummy2016-asia-restaurant01-de.4d38c964.png";